import React from "react";
import Head from "next/head";

import PrivacyPolicyMain from "@/components/privacy-policy/privacy-policy-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const PrivacyPolicy = () => {
  return (
    <>
      <Head>
        <title>{seoData.PRIVACY_POLICY.title}</title>
        <SeoMetaData data={seoData.PERSONAL_INFO_FORM} />
      </Head>

      <PrivacyPolicyMain />
    </>
  );
};

export default PrivacyPolicy;
